<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="text-left">
        <!-- Content of the left div -->
        <h3 id="statistic-summary" class="mb-1" style="font-size: 16px">Statistic Summary</h3>
      </div>
      <div class="text-right" style="min-width: 200px">
        <!-- Content of the right div -->
        <div class="input-group">
          <span
            class="input-group-text bg-white"
            style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right: none"
          >
            <i
              class="fas fa-calendar"
              style="
                position: absolute;
                left: 10px;
                top: 50%;
                transform: translateY(-50%);
                color: #333;
              "
            ></i>
          </span>
          <flat-pickr
            class="custom-datepicker"
            :config="rangePickr"
            placeholder="Select Date"
            v-model="selected.universalDate"
          ></flat-pickr>
        </div>
      </div>
    </div>

    <!-- Stats Start -->
    <template v-if="!isVanBelt">
      <div id="highlights-total-brakepad" class="highlights-total row mb-4 pt-3">
        <div class="col-lg-6 col-md-6 h-100">
          <div class="innerBox">
            <div class="py-2 pl-4 border-bottom">
              <span class="stats--title text-secondary fw-bold">
                QR Orders
                <b-button
                  :id="'html-tooltip-button-title-' + circle_bg_color"
                  variant="link"
                  class="p-0"
                  v-b-tooltip.hover
                >
                  <i class="fal fa-info-circle" style="color: #e6e6e6"></i>
                </b-button>

                <b-tooltip
                  :target="'html-tooltip-button-title-' + circle_bg_color"
                  triggers="hover"
                  custom-class="left-aligned-tooltip"
                  html
                >
                  <!-- <h5>QR Orders</h5> -->
                  Jumlah pesanan QR yang dimiliki maker.
                </b-tooltip>
              </span>
            </div>
            <div class="d-flex">
              <div :class="['col-5', { 'border-right': !isCrossClientCategory4 }]">
                <div class="content-highlights d-flex align-items-center h-100">
                  <div class="col-8 highlight--stats align-items-center order-2">
                    <div class="value--unit">
                      <b-tooltip
                        target="total-newStats"
                        triggers="hover"
                        custom-class="left-aligned-tooltip"
                        html
                        placement="bottom"
                      >
                        <template v-if="this.highlightData.newStats.total >= 1000">
                          Total QR Orders
                          <br />
                          <span style="color: #383838">
                            {{
                              Number(this.highlightData.newStats.total || 0).toLocaleString("en-US")
                            }}
                          </span>
                        </template>
                        <template v-else></template>
                      </b-tooltip>

                      <span class="stats--value" id="total-newStats">
                        {{ formatNumber(this.highlightData.newStats.total) }}
                        <span style="font-size: 14px; font-weight: 400">QR</span>
                      </span>
                    </div>
                  </div>
                  <div class="col-4 stats--icon justify-content-end align-items-center">
                    <!-- <div class="circle" :style="{
                      'background-color': circle_bg_color ? circle_bg_color : '#fff',
                      color: circle_text_color ? circle_text_color : '#000',
                    }">
                      <i class="far fa-2x fa-qrcode"></i>
                    </div> -->
                    <svg
                      width="57"
                      height="57"
                      viewBox="0 0 57 57"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="28.5" cy="28.5" r="28.5" fill="#F1EDFD" />
                      <path
                        d="M18 20C18 18.8954 18.8954 18 20 18H25C26.1046 18 27 18.8954 27 20V25C27 26.1046 26.1046 27 25 27H20C18.8954 27 18 26.1046 18 25V20Z"
                        fill="#A94AE4"
                      />
                      <path
                        d="M18 31C18 29.8954 18.8954 29 20 29H25C26.1046 29 27 29.8954 27 31V37C27 38.1046 26.1046 39 25 39H20C18.8954 39 18 38.1046 18 37V31Z"
                        fill="#A94AE4"
                      />
                      <path
                        d="M29 20C29 18.8954 29.8954 18 31 18H37C38.1046 18 39 18.8954 39 20V25C39 26.1046 38.1046 27 37 27H31C29.8954 27 29 26.1046 29 25V20Z"
                        fill="#A94AE4"
                      />
                      <path
                        d="M29.9783 34.9946C30.5002 34.9946 30.9233 34.5715 30.9233 34.0495V30.2693C30.9233 29.7473 30.5002 29.3242 29.9783 29.3242C29.4563 29.3242 29.0332 29.7473 29.0332 30.2693V34.0495C29.0332 34.5715 29.4563 34.9946 29.9783 34.9946Z"
                        fill="#A94AE4"
                      />
                      <path
                        d="M37.5387 31.2143H34.7036V30.2693C34.7036 29.7473 34.2804 29.3242 33.7585 29.3242C33.2366 29.3242 32.8134 29.7473 32.8134 30.2693V36.8847H29.9783C29.4563 36.8847 29.0332 37.3078 29.0332 37.8297C29.0332 38.3517 29.4563 38.7748 29.9783 38.7748H33.7585C34.2804 38.7748 34.7036 38.3517 34.7036 37.8297V33.1044H37.5387C38.0607 33.1044 38.4838 32.6813 38.4838 32.1594C38.4838 31.6375 38.0607 31.2143 37.5387 31.2143Z"
                        fill="#A94AE4"
                      />
                      <path
                        d="M37.5388 34.9941C37.0169 34.9941 36.5938 35.4173 36.5938 35.9392V37.8293C36.5938 38.3513 37.0169 38.7744 37.5388 38.7744C38.0607 38.7744 38.4839 38.3513 38.4839 37.8293V35.9392C38.4839 35.4173 38.0607 34.9941 37.5388 34.9941Z"
                        fill="#A94AE4"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="col-7" v-if="!isCrossClientCategory4">
                <div class="content-highlights d-flex align-items-center h-100" style="justify-content: center;">
                  <!-- Hitachi -->
                  <div class="total-product" id="hitachi-total">
                    <b-tooltip
                      target="hitachi-total"
                      triggers="hover"
                      custom-class="left-aligned-tooltip"
                      html
                      placement="bottom"
                    >
                      Hitachi
                      <br />
                      <span style="color: #383838">
                        {{
                          this.highlightData.newStats.total_hitachi >= 1000
                            ? Number(this.highlightData.newStats.total_hitachi || 0).toLocaleString(
                                "en-US"
                              )
                            : this.highlightData.newStats.total_hitachi || 0
                        }}
                      </span>
                    </b-tooltip>
                    <div class="flex-column px-2 py-2">
                      <span style="font-size: 10px">Hitachi</span>
                      <span>{{ formatNumber(this.highlightData.newStats.total_hitachi) }}</span>
                    </div>
                  </div>

                  <!-- Chemco -->
                  <div class="total-product" id="chemco-total">
                    <b-tooltip
                      target="chemco-total"
                      triggers="hover"
                      custom-class="left-aligned-tooltip"
                      html
                      placement="bottom"
                    >
                      Chemco
                      <br />
                      <span style="color: #383838">
                        {{
                          this.highlightData.newStats.total_chemco >= 1000
                            ? Number(this.highlightData.newStats.total_chemco || 0).toLocaleString(
                                "en-US"
                              )
                            : this.highlightData.newStats.total_chemco || 0
                        }}
                      </span>
                    </b-tooltip>
                    <div class="flex-column px-2 py-2">
                      <span style="font-size: 10px">Chemco</span>
                      <span>{{ formatNumber(this.highlightData.newStats.total_chemco) }}</span>
                    </div>
                  </div>

                  <!-- Nusametal -->
                  <div class="total-product" id="nusametal-total">
                    <b-tooltip
                      target="nusametal-total"
                      triggers="hover"
                      custom-class="left-aligned-tooltip"
                      html
                      placement="bottom"
                    >
                      Nusametal
                      <br />
                      <span style="color: #383838">
                        {{
                          this.highlightData.newStats.total_nusametal >= 1000
                            ? Number(
                                this.highlightData.newStats.total_nusametal || 0
                              ).toLocaleString("en-US")
                            : this.highlightData.newStats.total_nusametal || 0
                        }}
                      </span>
                    </b-tooltip>
                    <div class="flex-column px-2 py-2">
                      <span style="font-size: 10px">Nusametal</span>
                      <span>{{ formatNumber(this.highlightData.newStats.total_nusametal) }}</span>
                    </div>
                  </div>

                  <!-- Bando -->
                  <!-- <div class="total-product" id="bando-total">
                    <b-tooltip target="bando-total" triggers="hover" custom-class="left-aligned-tooltip" html placement="bottom">
                      Bando <br>
                      <span style="color: #383838;">
                        {{ this.highlightData.newStats.total_bando >= 1000 ? Number(this.highlightData.newStats.total_bando || 0).toLocaleString("en-US") : (this.highlightData.newStats.total_bando || 0) }}
                      </span>
                    </b-tooltip>
                    <div class="flex-column px-2 py-2">
                      <span style="font-size: 10px;">Bando</span>
                      <span>{{ formatNumber(this.highlightData.newStats.total_bando) }}</span>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 h-100">
          <div class="innerBox">
            <div class="py-2 px-4 border-bottom d-flex justify-content-between">
              <span class="stats--title text-secondary fw-bold">
                Scan Activity
                <b-button
                  :id="'html-tooltip-button-title-#ecf5fb'"
                  variant="link"
                  class="p-0"
                  v-b-tooltip.hover
                >
                  <i class="fal fa-info-circle" style="color: #e6e6e6"></i>
                </b-button>

                <b-tooltip
                  :target="'html-tooltip-button-title-#ecf5fb'"
                  triggers="hover"
                  custom-class="left-aligned-tooltip"
                  html
                >
                  <!-- <h5>Scan Activity</h5> -->
                  Scan QR yang dilakukan oleh customer.
                </b-tooltip>
              </span>
              <div>
                <span class="stats--title text-secondary fw-bold">
                  Total Scan Customer
                  <!-- <b-button :id="'html-tooltip-button-title-#ecf5fb'" variant="link" class="p-0" v-b-tooltip.hover>
                    <i class="fal fa-info-circle" style="color: grey"></i>
                  </b-button> -->

                  <!-- <b-tooltip :target="'html-tooltip-button-title-#ecf5fb'" triggers="hover" custom-class="left-aligned-tooltip" html>
                    <h5>Scan Activity</h5>
                    Akumulasi scan QR yang dilakukan oleh customer. Tampilan data berdasarkan range tanggal yang dipilih.
                  </b-tooltip> -->
                </span>
                <span class="stats--title text-secondary fw-bold ml-4" style="font-size: 16px">
                  {{ highlightData.stats.total_scan }}
                </span>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="col-lg-6 border-right">
                <div>
                  <div class="pt-2 pl-2">
                    <!-- <span class="stats--title text-secondary fw-bold">
                      Genuine QR
                      <b-button :id="'html-tooltip-button-title-#e6f5f0'" variant="link" class="p-0" v-b-tooltip.hover>
                        <i class="fal fa-info-circle" style="color: #E6E6E6"></i>
                      </b-button>

                      <b-tooltip :target="'html-tooltip-button-title-#e6f5f0'" triggers="hover"
                        custom-class="left-aligned-tooltip" html>
                        <h5>Scan Activity</h5>
                        Jumlah scan QR yang terdeteksi asli. Tampilan data berdasarkan range tanggal yang dipilih.
                      </b-tooltip>
                    </span> -->
                  </div>
                  <div class="content-highlights d-flex align-items-center">
                    <div class="col-8">
                      <span class="stats--title text-secondary fw-bold">
                        Genuine QR
                        <b-button
                          :id="'html-tooltip-button-title-#e6f5f0'"
                          variant="link"
                          class="p-0"
                          v-b-tooltip.hover
                        >
                          <i class="fal fa-info-circle" style="color: #e6e6e6"></i>
                        </b-button>

                        <b-tooltip
                          :target="'html-tooltip-button-title-#e6f5f0'"
                          triggers="hover"
                          custom-class="left-aligned-tooltip"
                          html
                        >
                          <!-- <h5>Scan Activity</h5> -->
                          Jumlah scan QR yang terdeteksi asli. Tampilan data berdasarkan range
                          tanggal yang dipilih.
                        </b-tooltip>
                      </span>
                      <div class="highlight--stats">
                        <div class="value--unit">
                          <span class="stats--value">
                            {{ this.highlightData.stats.genuine_found }}
                          </span>
                          <!-- <span class="stats--unit col-md-0 col-sm-0 col-xs-0">{{ unit }}</span> -->
                        </div>
                        <div class="text-left">
                          <template v-if="tooltipData">
                            <b-button
                              id="html-tooltip-button"
                              variant="link"
                              class="p-0"
                              v-b-tooltip.hover
                            >
                              <h5>
                                <span style="font-weight: normal">View Detail</span>
                              </h5>
                            </b-button>
                            <b-tooltip
                              target="html-tooltip-button"
                              triggers="hover"
                              custom-class="left-aligned-tooltip"
                              html
                            >
                              <br />
                              <!-- <b>{{ formatNumberWithCommas(tooltipData.total_product) }}</b> Product <br><br> -->
                              <b>{{ formatNumberWithCommas(tooltipData.total_unmaped) }}</b>
                              Inactive
                              <br />
                              <br />
                              <b>{{ formatNumberWithCommas(tooltipData.total_mapped) }}</b>
                              Active
                              <br />
                              <br />
                            </b-tooltip>
                          </template>
                          <template v-else-if="routeToPage">
                            <h5 style="color: #348fe2; cursor: pointer">
                              <span
                                style="font-weight: normal"
                                @click="
                                  $router.push({
                                    name: routeToPage,
                                    query: pageQuery,
                                  })
                                "
                              >
                                View Location
                              </span>
                            </h5>
                          </template>
                          <template v-else>
                            <h5 style="color: white">-</h5>
                          </template>
                        </div>
                      </div>
                    </div>
                    <div class="col-4 stats--icon justify-content-end align-items-center">
                      <div
                        class="circle"
                        :style="{
                          'background-color': '#e6f5f0' ? '#e6f5f0' : '#fff',
                          color: '#20c661' ? '#20c661' : '#000',
                        }"
                      >
                        <!-- <i class="far fa-2x fa-check"></i> -->
                        <font-awesome-icon icon="check" size="2x" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div>
                  <div class="pt-2 pl-2">
                    <!-- <span class="stats--title text-secondary fw-bold">
                      Counterfeit Found
                      <b-button :id="'html-tooltip-button-title-#d05555'" variant="link" class="p-0" v-b-tooltip.hover>
                        <i class="fal fa-info-circle" style="color: #E6E6E6"></i>
                      </b-button>

                      <b-tooltip :target="'html-tooltip-button-title-#d05555'" triggers="hover"
                        custom-class="left-aligned-tooltip" html>
                        <h5>Scan Activity</h5>
                        Jumlah scan QR yang melakukan scan lebih dari 5 kali. Tampilan data berdasarkan range tanggal
                        yang dipilih.
                      </b-tooltip>
                    </span> -->
                  </div>
                  <div class="content-highlights d-flex align-items-center">
                    <div class="col-8">
                      <span class="stats--title text-secondary fw-bold">
                        Counterfeit Found
                        <b-button
                          :id="'html-tooltip-button-title-#d05555'"
                          variant="link"
                          class="p-0"
                          v-b-tooltip.hover
                        >
                          <i class="fal fa-info-circle" style="color: #e6e6e6"></i>
                        </b-button>

                        <b-tooltip
                          :target="'html-tooltip-button-title-#d05555'"
                          triggers="hover"
                          custom-class="left-aligned-tooltip"
                          html
                        >
                          <!-- <h5>Scan Activity</h5> -->
                          <template v-if="useCustomCounterfeitTooltip">
                            Jumlah scan QR yang lebih dari 5x <br>
                            dan tidak dikenali. Tampilan data <br>
                            berdasarkan range tanggal yang <br>
                            dipilih
                          </template>
                          <template v-else>
                            Jumlah scan QR yang lebih dari 5x, tidak aktif dan tidak dikenali.
                            Tampilan data berdasarkan range tanggal yang dipilih
                          </template>
                        </b-tooltip>
                      </span>
                      <div class="highlight--stats">
                        <div class="value--unit">
                          <span class="stats--value">
                            {{ this.highlightData.stats.counterfeit_found }}
                          </span>
                          <!-- <span class="stats--unit col-md-0 col-sm-0 col-xs-0">{{ unit }}</span> -->
                        </div>
                        <div class="text-left">
                          <template v-if="tooltipData">
                            <b-button
                              id="html-tooltip-button"
                              variant="link"
                              class="p-0"
                              v-b-tooltip.hover
                            >
                              <h5>
                                <span style="font-weight: normal">View Detail</span>
                              </h5>
                            </b-button>
                            <b-tooltip
                              target="html-tooltip-button"
                              triggers="hover"
                              custom-class="left-aligned-tooltip"
                              html
                            >
                              <br />
                              <!-- <b>{{ formatNumberWithCommas(tooltipData.total_product) }}</b> Product <br><br> -->
                              <b>{{ formatNumberWithCommas(tooltipData.total_unmaped) }}</b>
                              Inactive
                              <br />
                              <br />
                              <b>{{ formatNumberWithCommas(tooltipData.total_mapped) }}</b>
                              Active
                              <br />
                              <br />
                            </b-tooltip>
                          </template>
                          <template>
                            <h5 style="color: #348fe2; cursor: pointer; font-size: 12px">
                              <!-- confirmNavigation -->
                              <span
                                style="font-weight: normal; color: #267ce5"
                                @click="handleClick"
                              >
                                View Location
                              </span>
                            </h5>
                          </template>
                        </div>
                      </div>
                    </div>
                    <div class="col-4 stats--icon justify-content-end align-items-center">
                      <div
                        class="circle"
                        :style="{
                          'background-color': '#ffe8e8' ? '#ffe8e8' : '#fff',
                          color: '#d05555' ? '#d05555' : '#000',
                        }"
                      >
                        <!-- <i class="far fa-2x fa-times"></i> -->
                        <font-awesome-icon icon="times" size="2x" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div id="highlights-total-vanbelt" class="highlights-total row mb-4 pt-3">
        <div class="col-lg-6 col-md-6 h-100">
          <div class="innerBox">
            <div class="py-2 pl-4 border-bottom">
              <span class="stats--title text-secondary fw-bold">
                QR Orders
                <b-button
                  :id="'html-tooltip-button-title-' + circle_bg_color"
                  variant="link"
                  class="p-0"
                  v-b-tooltip.hover
                >
                  <i class="fal fa-info-circle" style="color: #e6e6e6"></i>
                </b-button>

                <b-tooltip
                  :target="'html-tooltip-button-title-' + circle_bg_color"
                  triggers="hover"
                  custom-class="left-aligned-tooltip"
                  html
                >
                  <!-- <h5>QR Orders</h5> -->
                  Jumlah pesanan QR yang dimiliki maker.
                </b-tooltip>
              </span>
            </div>
            <div class="d-flex">
              <div class="col-12 border-right">
                <div class="content-highlights d-flex align-items-center h-100">
                  <div class="col-8 highlight--stats">
                    <div
                      class="value--unit"
                      style="flex-direction: column; align-items: flex-start"
                    >
                      <span class="stats--value">
                        {{ this.highlightData.newStats.total }}
                        <span style="font-size: 14px; font-weight: 400">QR</span>
                      </span>
                      <!-- <span class="stats--unit col-md-0 col-sm-0 col-xs-0">{{ unit }}</span> -->
                      <div
                        style="
                          font-family: 'Proxima Nova', sans-serif;
                          font-weight: 500;
                          font-size: 12px;
                          color: #a0a0a0;
                          margin-top: 4px;
                        "
                      >
                        Bando Indonesia
                      </div>
                    </div>
                  </div>
                  <div class="col-4 stats--icon justify-content-end align-items-center">
                    <!-- <div class="circle" :style="{
                      'background-color': circle_bg_color ? circle_bg_color : '#fff',
                      color: circle_text_color ? circle_text_color : '#000',
                    }">
                      <i class="far fa-2x fa-qrcode"></i>
                    </div> -->

                    <svg
                      width="57"
                      height="57"
                      viewBox="0 0 57 57"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="28.5" cy="28.5" r="28.5" fill="#F1EDFD" />
                      <path
                        d="M18 20C18 18.8954 18.8954 18 20 18H25C26.1046 18 27 18.8954 27 20V25C27 26.1046 26.1046 27 25 27H20C18.8954 27 18 26.1046 18 25V20Z"
                        fill="#A94AE4"
                      />
                      <path
                        d="M18 31C18 29.8954 18.8954 29 20 29H25C26.1046 29 27 29.8954 27 31V37C27 38.1046 26.1046 39 25 39H20C18.8954 39 18 38.1046 18 37V31Z"
                        fill="#A94AE4"
                      />
                      <path
                        d="M29 20C29 18.8954 29.8954 18 31 18H37C38.1046 18 39 18.8954 39 20V25C39 26.1046 38.1046 27 37 27H31C29.8954 27 29 26.1046 29 25V20Z"
                        fill="#A94AE4"
                      />
                      <path
                        d="M29.9783 34.9946C30.5002 34.9946 30.9233 34.5715 30.9233 34.0495V30.2693C30.9233 29.7473 30.5002 29.3242 29.9783 29.3242C29.4563 29.3242 29.0332 29.7473 29.0332 30.2693V34.0495C29.0332 34.5715 29.4563 34.9946 29.9783 34.9946Z"
                        fill="#A94AE4"
                      />
                      <path
                        d="M37.5387 31.2143H34.7036V30.2693C34.7036 29.7473 34.2804 29.3242 33.7585 29.3242C33.2366 29.3242 32.8134 29.7473 32.8134 30.2693V36.8847H29.9783C29.4563 36.8847 29.0332 37.3078 29.0332 37.8297C29.0332 38.3517 29.4563 38.7748 29.9783 38.7748H33.7585C34.2804 38.7748 34.7036 38.3517 34.7036 37.8297V33.1044H37.5387C38.0607 33.1044 38.4838 32.6813 38.4838 32.1594C38.4838 31.6375 38.0607 31.2143 37.5387 31.2143Z"
                        fill="#A94AE4"
                      />
                      <path
                        d="M37.5388 34.9941C37.0169 34.9941 36.5938 35.4173 36.5938 35.9392V37.8293C36.5938 38.3513 37.0169 38.7744 37.5388 38.7744C38.0607 38.7744 38.4839 38.3513 38.4839 37.8293V35.9392C38.4839 35.4173 38.0607 34.9941 37.5388 34.9941Z"
                        fill="#A94AE4"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <!-- <div class="col-6">
                <div class="content-highlights d-flex align-items-center h-100">
                  <div class="total-product">
                    <div class="flex-column px-2 py-2">
                      <span>Hitachi</span>
                      <span>{{ this.highlightData.newStats.total_hitachi }}</span>
                    </div>
                  </div>
                  <div class="total-product">
                    <div class="flex-column px-2 py-2">
                      <span>Chemco</span>
                      <span>{{ this.highlightData.newStats.total_chemco }}</span>
                    </div>
                  </div>
                  <div class="total-product">
                    <div class="flex-column px-2 py-2">
                      <span>Nusametal</span>
                      <span>{{ this.highlightData.newStats.total_nusametal }}</span>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 h-100">
          <div class="innerBox">
            <div class="py-2 px-4 border-bottom d-flex justify-content-between">
              <span class="stats--title text-secondary fw-bold">
                Scan Activity
                <b-button
                  :id="'html-tooltip-button-title-#ecf5fb'"
                  variant="link"
                  class="p-0"
                  v-b-tooltip.hover
                >
                  <i class="fal fa-info-circle" style="color: #e6e6e6"></i>
                </b-button>

                <b-tooltip
                  :target="'html-tooltip-button-title-#ecf5fb'"
                  triggers="hover"
                  custom-class="left-aligned-tooltip"
                  html
                >
                  <!-- <h5>Scan Activity</h5> -->
                  Scan QR yang dilakukan oleh customer.
                </b-tooltip>
              </span>
              <div>
                <span class="stats--title text-secondary fw-bold">
                  Total Scan Customer
                  <!-- <b-button :id="'html-tooltip-button-title-#ecf5fb'" variant="link" class="p-0" v-b-tooltip.hover>
                    <i class="fal fa-info-circle" style="color: #E6E6E6"></i>
                  </b-button> -->

                  <!-- <b-tooltip :target="'html-tooltip-button-title-#ecf5fb'" triggers="hover" custom-class="left-aligned-tooltip" html>
                    <h5>Scan Activity</h5>
                    Akumulasi scan QR yang dilakukan oleh customer. Tampilan data berdasarkan range tanggal yang dipilih.
                  </b-tooltip> -->
                </span>
                <span class="stats--title text-secondary fw-bold ml-4" style="font-size: 16px">
                  {{ highlightData.stats.total_scan }}
                </span>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="col-lg-6 border-right">
                <div>
                  <div class="pt-2 pl-2">
                    <!-- <span class="stats--title text-secondary fw-bold">
                      Genuine QR
                      <b-button :id="'html-tooltip-button-title-#e6f5f0'" variant="link" class="p-0" v-b-tooltip.hover>
                        <i class="fal fa-info-circle" style="color: #E6E6E6"></i>
                      </b-button>

                      <b-tooltip :target="'html-tooltip-button-title-#e6f5f0'" triggers="hover"
                        custom-class="left-aligned-tooltip" html>
                        <h5>Scan Activity</h5>
                        Jumlah scan QR yang terdeteksi asli. Tampilan data berdasarkan range tanggal yang dipilih.
                      </b-tooltip>
                    </span> -->
                  </div>
                  <div class="content-highlights d-flex align-items-center">
                    <div class="col-8">
                      <span class="stats--title text-secondary fw-bold">
                        Genuine QR
                        <b-button
                          :id="'html-tooltip-button-title-#e6f5f0'"
                          variant="link"
                          class="p-0"
                          v-b-tooltip.hover
                        >
                          <i class="fal fa-info-circle" style="color: #e6e6e6"></i>
                        </b-button>

                        <b-tooltip
                          :target="'html-tooltip-button-title-#e6f5f0'"
                          triggers="hover"
                          custom-class="left-aligned-tooltip"
                          html
                        >
                          <!-- <h5>Scan Activity</h5> -->
                          Jumlah scan QR yang terdeteksi asli. Tampilan data berdasarkan range
                          tanggal yang dipilih.
                        </b-tooltip>
                      </span>
                      <div class="highlight--stats">
                        <div class="value--unit">
                          <span class="stats--value">
                            {{ this.highlightData.stats.genuine_found }}
                          </span>
                          <!-- <span class="stats--unit col-md-0 col-sm-0 col-xs-0">{{ unit }}</span> -->
                        </div>
                        <div class="text-left">
                          <template v-if="tooltipData">
                            <b-button
                              id="html-tooltip-button"
                              variant="link"
                              class="p-0"
                              v-b-tooltip.hover
                            >
                              <h5>
                                <span style="font-weight: normal">View Detail</span>
                              </h5>
                            </b-button>
                            <b-tooltip
                              target="html-tooltip-button"
                              triggers="hover"
                              custom-class="left-aligned-tooltip"
                              html
                            >
                              <br />
                              <!-- <b>{{ formatNumberWithCommas(tooltipData.total_product) }}</b> Product <br><br> -->
                              <b>{{ formatNumberWithCommas(tooltipData.total_unmaped) }}</b>
                              Inactive
                              <br />
                              <br />
                              <b>{{ formatNumberWithCommas(tooltipData.total_mapped) }}</b>
                              Active
                              <br />
                              <br />
                            </b-tooltip>
                          </template>
                          <template v-else-if="routeToPage">
                            <h5 style="color: #348fe2; cursor: pointer">
                              <span
                                style="font-weight: normal"
                                @click="
                                  $router.push({
                                    name: routeToPage,
                                    query: pageQuery,
                                  })
                                "
                              >
                                View Location
                              </span>
                            </h5>
                          </template>
                          <template v-else>
                            <h5 style="color: white">-</h5>
                          </template>
                        </div>
                      </div>
                    </div>
                    <div class="col-4 stats--icon justify-content-end align-items-center">
                      <div
                        class="circle"
                        :style="{
                          'background-color': '#e6f5f0' ? '#e6f5f0' : '#fff',
                          color: '#20c661' ? '#20c661' : '#000',
                        }"
                      >
                        <i class="far fa-2x fa-check"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div>
                  <div class="pt-2 pl-2">
                    <!-- <span class="stats--title text-secondary fw-bold">
                      Counterfeit Found
                      <b-button :id="'html-tooltip-button-title-#d05555'" variant="link" class="p-0" v-b-tooltip.hover>
                        <i class="fal fa-info-circle" style="color: #E6E6E6"></i>
                      </b-button>

                      <b-tooltip :target="'html-tooltip-button-title-#d05555'" triggers="hover"
                        custom-class="left-aligned-tooltip" html>
                        <h5>Scan Activity</h5>
                        Jumlah scan QR yang melakukan scan lebih dari 5 kali. Tampilan data berdasarkan range tanggal
                        yang dipilih.
                      </b-tooltip>
                    </span> -->
                  </div>
                  <div class="content-highlights d-flex align-items-center">
                    <div class="col-8">
                      <span class="stats--title text-secondary fw-bold">
                        Counterfeit Found
                        <b-button
                          :id="'html-tooltip-button-title-#d05555'"
                          variant="link"
                          class="p-0"
                          v-b-tooltip.hover
                        >
                          <i class="fal fa-info-circle" style="color: #e6e6e6"></i>
                        </b-button>

                        <b-tooltip
                          :target="'html-tooltip-button-title-#d05555'"
                          triggers="hover"
                          custom-class="left-aligned-tooltip"
                          html
                        >
                          <template v-if="useCustomCounterfeitTooltip">
                            Jumlah scan QR yang lebih dari 5x <br>
                            dan tidak dikenali. Tampilan data <br>
                            berdasarkan range tanggal yang <br>
                            dipilih
                          </template>
                          <template v-else>
                            Jumlah scan QR yang lebih dari 5x, tidak aktif dan tidak dikenali.
                            Tampilan data berdasarkan range tanggal yang dipilih
                          </template>
                        </b-tooltip>
                      </span>
                      <div class="highlight--stats">
                        <div class="value--unit">
                          <span class="stats--value">
                            {{ this.highlightData.stats.counterfeit_found }}
                          </span>
                          <!-- <span class="stats--unit col-md-0 col-sm-0 col-xs-0">{{ unit }}</span> -->
                        </div>
                        <div class="text-left">
                          <template v-if="tooltipData">
                            <b-button
                              id="html-tooltip-button"
                              variant="link"
                              class="p-0"
                              v-b-tooltip.hover
                            >
                              <h5>
                                <span style="font-weight: normal">View Detail</span>
                              </h5>
                            </b-button>
                            <b-tooltip
                              target="html-tooltip-button"
                              triggers="hover"
                              custom-class="left-aligned-tooltip"
                              html
                            >
                              <br />
                              <!-- <b>{{ formatNumberWithCommas(tooltipData.total_product) }}</b> Product <br><br> -->
                              <b>{{ formatNumberWithCommas(tooltipData.total_unmaped) }}</b>
                              Inactive
                              <br />
                              <br />
                              <b>{{ formatNumberWithCommas(tooltipData.total_mapped) }}</b>
                              Active
                              <br />
                              <br />
                            </b-tooltip>
                          </template>
                          <template>
                            <h5 style="color: #348fe2; cursor: pointer; font-size: 12px">
                              <!-- confirmNavigation -->
                              <span
                                style="font-weight: normal; color: #267ce5"
                                @click="handleClick"
                              >
                                View Location
                              </span>
                            </h5>
                          </template>
                        </div>
                      </div>
                    </div>
                    <div class="col-4 stats--icon justify-content-end align-items-center">
                      <div
                        class="circle"
                        :style="{
                          'background-color': '#ffe8e8' ? '#ffe8e8' : '#fff',
                          color: '#d05555' ? '#d05555' : '#000',
                        }"
                      >
                        <i class="far fa-2x fa-times"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- <template v-else>
      <div class="row mb-4">
        <div class="col-lg-3 col-md-6">
          <div class="innerBox mt-3">
            <highlight-stats title="Total QR" :value="highlightData.stats.total_qr" :tooltipText="'Total QR'" :tooltipBody="'Akumulasi QR yang sudah dipesan.'" unit="Activities" icon="fa-qrcode" circle_bg_color="#f1edfc" circle_text_color="#a94be4" :tooltipData="tooltipDataTotalQR"></highlight-stats>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="innerBox mt-3">
            <highlight-stats title="Total Scan" :tooltipText="'Total Scan'" :tooltipBody="'Akumulasi scan QR yang dilakukan oleh customer. Tampilan data berdasarkan range tanggal yang dipilih.'" :value="highlightData.stats.total_scan" unit="Activities" icon="fa-barcode-read" circle_bg_color="#ecf5fb" circle_text_color="#267de4"></highlight-stats>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="innerBox mt-3">
            <highlight-stats title="Genuine Found" :tooltipText="'Genuine Found'" :tooltipBody="'Akumulasi hasil deteksi QR asli ditampilkan kepada customer. Tampilan data berdasarkan range tanggal yang dipilih.'" :value="highlightData.stats.genuine_found" unit="Activities" icon="fa-check" circle_bg_color="#e6f5f0" circle_text_color="#20c661"></highlight-stats>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="innerBox mt-3">
            <highlight-stats
              title="Counterfeit Found"
              :tooltipText="'Counteirfeit Found'"
              :tooltipBody="'Akumulasi hasil deteksi QR palsu ditampilkan kepada customer. Tampilan data berdasarkan range tanggal yang dipilih.'"
              :value="highlightData.stats.counterfeit_found"
              unit="Activities"
              icon="fa-times"
              circle_bg_color="#ffe8e8"
              circle_text_color="#d05555"
              :routeToPage="'HighlightsCounterfeitLocation'"
              :pageQuery="{
                start: filter.stats.start,
                end: filter.stats.end,
              }"
            ></highlight-stats>
          </div>
        </div>
      </div>
    </template> -->
    <!-- Stats End -->

    <!-- Chart Start -->
    <!-- <div class="mb-4">
            <div class="innerBox">
                <div class="row">
                    <div class="col-lg-3 col-12 mb-1">
                        <h5>Activity Trend</h5>
                    </div>
                    <div class=" offset-lg-2 col-lg-2 col-12 mb-1">
                        <Multiselect 
                            :options="filterOptions.provinsi.map(x => x.kode_provinsi)"
                            :custom-label="opt => filterOptions.provinsi.find(x => x.kode_provinsi == opt).nama_provinsi"
                            placeholder="All Province"
                            v-model="filter.activityTrend.province_id"
                        />
                    </div>
                    <div class="col-lg-2 col-12 mb-1">
                        <Multiselect 
                            :options="filterOptions.products.map(x => x.id)"
                            :custom-label="opt => filterOptions.products.find(x => x.id == opt).name"
                            placeholder="All Product"
                            v-model="filter.activityTrend.product_id"

                        />
                    </div>
                    <div class="col-lg-3 col-12 mb-1 d-flex justify-content-between">
                        <button class="btn  flex-fill mr-2" @click="filter.period = 'This Year'" :class="{'btn-primary' : filter.period == 'This Year' , 'btn-outline-primary' : filter.period != 'This Year'}">This Year</button>
                        <button class="btn flex-fill" @click="filter.period = 'Last 12 Months'" :class="{'btn-primary' : filter.period == 'Last 12 Months' , 'btn-outline-primary' : filter.period != 'Last 12 Months'}">Last 12 Months</button>
                    </div>
                </div>
                <hr class="mt-1">
                <highlight-chart :data="highlightData.activityTrend" v-if="highlightData.activityTrend.length > 0">
                </highlight-chart>
            </div>
        </div> -->
    <!-- Chart End -->

    <!-- Map Start -->
    <div class="mb-4 innerBox" style="padding-left: 10px; padding-right: 0; padding-bottom: 0">
      <div class="row">
        <div class="col-lg-4 col-12" style="height: 43px; display: flex; align-items: center">
          <div>
            <h5 class="mb-0">
              <span
                class="back_Button"
                v-if="!isIndonesia"
                @click="updateIsIndonesia(true)"
                style="color: #9d9d9d !important; font-size: 17px; font-weight: 500"
              >
                Back ||
              </span>
              <span class="mr-2 fw-bold" style="font-size: 13px">Activity Location</span>
              <b-button
                variant="link"
                class="p-0"
                id="activity-location"
                v-b-tooltip.hover
                :title="tooltipText"
              >
                <i class="fal fa-info-circle" style="color: #e6e6e6"></i>
              </b-button>
              <b-tooltip
                target="activity-location"
                triggers="hover"
                custom-class="left-aligned-tooltip"
                html
              >
                <h5>Activity Location</h5>
                <!-- <br> -->
                Aktifitas scan yang tersebar diberbagai provinsi dengan representatif data scan
              Genuine, Counterfeit dan semua result scan.
                <!-- {{ 'html-tooltip-button-title-' + circle_bg_color }} -->
              </b-tooltip>
            </h5>
          </div>

          <!-- <div class="container w-100">
                            <div class="input-group">
                                <select class="form-select" style="width: 38%;" v-model="filter.map.filter_by">
                                    <option selected value="serial_number">Search By Serial Number</option>
                                    <option selected value="product">Search by Part Number Name</option>
                                </select>
    
                                <div class="input-with-icon" style="width: 62%;">
                                    <input type="text" class="form-control" placeholder="Search" style="padding-left: 30px;" v-model="filter.map.search"/>
                                    <span class="fa-placeholder"><i class="fa fa-search fa-lg"></i></span>
                                </div>

                            </div>
                        </div> -->
        </div>
        <div class="dropdown-custom offset-lg-5 col-lg-3 col-12 mb-1">
          <Multiselect
            :options="['all result', 'genuine', 'counterfeit']"
            :custom-label="titleCase"
            :allow-empty="false"
            v-model="filter.map.status"
            :show-labels="false"
          ></Multiselect>
        </div>
        <!-- <div class="offset-lg-3 col-lg-3 col-12 mb-1">

                        <flat-pickr
                            :config="rangePickr"
                            placeholder="Select Date"
                            v-model="selected.date"
                        ></flat-pickr>
                    </div> -->
      </div>
      <hr class="mt-3" style="margin-bottom: 0" />

      <div class="row">
        <div
          class="col-lg-9 col-md-12 col-12"
          style="border-right: 1px solid #ccc; padding-left: 0; padding-right: 0"
        >
          <!-- <Map
                            v-if="highlightData.mostActiveRegion"
                            :data="highlightData.mostActiveRegion"
                        ></Map> -->
          <GoogleMap
            v-if="highlightData.mostActiveRegion"
            :data="highlightData.mostActiveRegion"
            :masterLegend="masterLegend"
            :status="filter.map.status"
            @wheel="handleMapWheel"
          />
        </div>
        <div class="col-lg-3 col-md-12 col-12" style="padding-left: 0">
          <div>
            <h5 style="padding-left: 10px; margin-top: 16px">Most Active Region</h5>
            <hr />
          </div>
          <template v-if="highlightData.mostActiveRegion">
            <div
              class="mb-3"
              style="padding-left: 10px; padding-right: 10px"
              v-for="(data, index) in highlightData.mostActiveRegion.slice(0, 5)"
            >
              <h6>{{ data.nama_provinsi }}</h6>
              <span style="color: #bebebe">
                {{
                  numberWithCommas(
                    parseInt(filter.map.status == "counterfeit" ? data.counterfeit : data.genuine)
                  )
                }}
                {{ filter.map.status == "counterfeit" ? "Counterfeit" : "Genuine" }}
                out of {{ numberWithCommas(data.total_scan) }} scan
              </span>
              <div class="progress-container">
                <div
                  class="progress"
                  :style="{
                    background: filter.map.status != 'all result' ? '#e4e7ea' : '#f30406',
                  }"
                >
                  <div
                    class="progress-bar"
                    role="progressbar"
                    v-if="filter.map.status == 'all result'"
                    :style="{
                      width: data.percentage + '%',
                      backgroundColor: data.percentage >= 50 ? '#20a668' : '#d73737',
                    }"
                    :aria-valuenow="data.percentage"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>

                  <div
                    v-else
                    class="progress-bar"
                    role="progressbar"
                    :style="{
                      width: data.percentage + '%',
                      backgroundColor: getColorForValue(
                        data.percentage,
                        masterLegend[filter.map.status]
                      ),
                    }"
                    :aria-valuenow="data.percentage"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <div class="value-label" style="font-weight: bold">
                  {{ Math.floor(data.percentage) }} %
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- Map End -->

    <!-- Frequently Scanned Product Start -->

    <div class="mb-4 innerBox" style="padding: 20px 0">
      <div style="display: flex; flex-direction: row; align-items: center">
        <h5 class="mb-0 mr-4 fw-bold" style="padding: 0 20px; font-size: 13px">
          Frequently Scanned Product
          <b-button
            variant="link"
            class="p-0"
            id="frequently-scanned-product"
            v-b-tooltip.hover
            :title="tooltipText"
          >
            <i class="fal fa-info-circle" style="color: #e6e6e6"></i>
          </b-button>
          <b-tooltip
            target="frequently-scanned-product"
            triggers="hover"
            custom-class="left-aligned-tooltip"
            html
          >
            <h5>Frequently Scanned Product</h5>
            <!-- <br> -->
            Produk yang sering di scan oleh customer
            <!-- {{ 'html-tooltip-button-title-' + circle_bg_color }} -->
          </b-tooltip>
        </h5>
        <div class="mr-4">
          <div
            class="input-group"
            style="
              position: relative;
              display: flex;
              flex-wrap: nowrap;
              align-items: stretch;
              width: 100%;
            "
          >
            <div class="input-group-append">
              <button
                class="btn btn-outline-light text-gray bg-white"
                type="button"
                style="border-color: #d5dbe0; border-right: none; pointer-events: none"
              >
                <i class="fa fa-search"></i>
                <!-- Assuming you're using Font Awesome for the magnifier icon -->
              </button>
            </div>
            <Multiselect
              :options="[
                ...new Set(highlightData.frequentlyScannedProduct.map((x) => x.material_no)),
              ]"
              placeholder="Search by Part Number"
              v-model="filter.frequentlyScannedProduct.material_no"
              class="custom-multiselect no-caret flex-grow-1"
              :show-labels="false"
            />
          </div>
        </div>
      </div>
      <!-- <div class="row">
                    <div class="col-lg-4 col-12 mt-auto mb-auto">
                        <h5>Frequently Scanned Product
                            <b-button variant="link" class="p-0" v-b-tooltip.hover :title="tooltipText">
                                <i class="fal fa-info-circle" style="color:#E6E6E6></i>
                            </b-button>
                        </h5>
                    </div>
                    <div class="offset-lg-5 col-lg-3 col-12 mb-1">
                        <flat-pickr
                            :config="rangePickr"
                            placeholder="Select Date"
                            v-model="selected.topScanDate"
                        ></flat-pickr>
                    </div>
                </div> -->
      <hr class="mt-3" style="margin-bottom: 0" />

      <div class="row">
        <div class="col-lg-8 col-md-12 col-12 mb-2" style="padding-left: 10px">
          <table class="table frequently-scanned-table">
            <thead>
              <th
                class="frequently-scanned-table-header"
                style="border-top: none; padding-left: 20px"
              >
                Product Name
              </th>
              <th class="frequently-scanned-table-header" style="border-top: none">Part Number</th>
              <th
                class="frequently-scanned-table-header"
                style="border-top: none"
                @click="toggleSort"
              >
                Total Scan
                <span class="sort asc" v-if="sortOrder === 'asc'">
                  <!-- <svg fill="#000000" height="100%" width="100%" version="1.1" id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 330"
                    xml:space="preserve">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path id="XMLID_225_"
                        d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z">
                      </path>
                    </g>
                  </svg> -->
                  <svg
                    width="6"
                    height="12"
                    viewBox="0 0 6 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M3 0L5.59808 3.75H0.401924L3 0Z" fill="#D9D9D9" />
                    <path d="M3 12L0.401924 8.25H5.59808L3 12Z" fill="#D9D9D9" />
                  </svg>
                </span>
                <span class="sort" v-else>
                  <!-- <svg fill="#000000" height="100%" width="100%" version="1.1" id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 330"
                    xml:space="preserve">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path id="XMLID_225_"
                        d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z">
                      </path>
                    </g>
                  </svg> -->
                  <svg
                    width="6"
                    height="12"
                    viewBox="0 0 6 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M3 0L5.59808 3.75H0.401924L3 0Z" fill="#D9D9D9" />
                    <path d="M3 12L0.401924 8.25H5.59808L3 12Z" fill="#D9D9D9" />
                  </svg>
                </span>
              </th>
              <th
                class="frequently-scanned-table-header"
                style="border-top: none; font-weight: bold"
              >
                Action
              </th>
            </thead>
            <tbody style="color: #393939">
              <tr
                style="border-top: 1px solid #e6e6e6"
                v-for="data in sortedProducts.slice(
                  (filter.frequentlyScannedProduct.page - 1) *
                    filter.frequentlyScannedProduct.limit,
                  filter.frequentlyScannedProduct.page * filter.frequentlyScannedProduct.limit
                )"
                :key="data.id"
              >
                <td style="min-width: 225px; clear: both; padding-left: 20px">
                  <img
                    :src="data.image"
                    class="mr-2"
                    style="
                      width: 45px;
                      height: auto;
                      border: 1px solid #e6e6e6;
                      border-radius: 10px;
                    "
                  />
                  {{ data.name }}
                </td>
                <td class="max-description">
                  {{ data.material_no }}
                </td>
                <td>
                  {{ numberWithCommas(data.total) }}
                </td>
                <td>
                  <button
                    class="btn btn-outline-primary"
                    @click="openFrequentlyScannedProductMap(data)"
                  >
                    <i class="fa fa-map-marker-alt"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-4 col-md-12 col-12 mb-2">
          <FrequentlyScannedProductPieChart :data="frequentlyScannedProductShownData" />
        </div>
      </div>
      <hr class="mt-3" />
      <div
        style="display: flex; align-items: center; justify-content: start; padding-left: 20px"
        class="w-100"
      >
        <div class="mr-3" style="color: #cbcbcb; font-size: 14px; font-family: 'Inter', sans-serif">
          Showing
          {{
            (filter.frequentlyScannedProduct.page - 1) * filter.frequentlyScannedProduct.limit + 1
          }}
          -
          {{
            filter.frequentlyScannedProduct.page * filter.frequentlyScannedProduct.limit <
            frequentlyScannedProductShownData.length
              ? filter.frequentlyScannedProduct.page * filter.frequentlyScannedProduct.limit
              : frequentlyScannedProductShownData.length
          }}
          of {{ frequentlyScannedProductShownData.length }} items
        </div>
        <!-- <button class="btn mr-2" @click="filter.frequentlyScannedProduct.page = 1"
              :disabled="filter.frequentlyScannedProduct.page === 1">&laquo;</button> -->
        <button
          class="btn"
          style="padding: 4px 8px"
          @click="filter.frequentlyScannedProduct.page -= 1"
          :disabled="filter.frequentlyScannedProduct.page === 1"
        >
          &lsaquo;
        </button>
        <!-- <span>Page {{ filter.frequentlyScannedProduct.page }} of {{
              Math.ceil(frequentlyScannedProductShownData.length /
                filter.frequentlyScannedProduct.limit) }}</span> -->
        <button
          class="btn"
          style="padding: 4px 8px"
          @click="filter.frequentlyScannedProduct.page += 1"
          :disabled="
            filter.frequentlyScannedProduct.page >=
            Math.ceil(
              frequentlyScannedProductShownData.length / filter.frequentlyScannedProduct.limit
            )
          "
        >
          &rsaquo;
        </button>
        <!-- <button class="btn ml-2"
              @click="filter.frequentlyScannedProduct.page = Math.ceil(frequentlyScannedProductShownData.length / filter.frequentlyScannedProduct.limit)"
              :disabled="filter.frequentlyScannedProduct.page >= Math.ceil(frequentlyScannedProductShownData.length / filter.frequentlyScannedProduct.limit)">&raquo;</button> -->
      </div>
    </div>
    <!-- Frequently Scanned Product End -->

    <!-- Frequently Scanned Serial Number Start -->
    <div class="mb-4 innerBox" style="padding: 20px 0">
      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div style="display: flex; flex-direction: row; align-items: center">
          <h5 class="mb-0 mr-4 fw-bold" style="padding: 0 20px; font-size: 13px">
            Frequently Scanned Serial Number
            <b-button
              variant="link"
              class="p-0"
              v-b-tooltip.hover
              id="frequently-scanned-serial"
              :title="tooltipText"
            >
              <i class="fal fa-info-circle" style="color: #e6e6e6"></i>
            </b-button>
            <b-tooltip
              target="frequently-scanned-serial"
              triggers="hover"
              custom-class="left-aligned-tooltip"
              html
            >
              <h5>Frequently Scanned Serial Number</h5>
              <!-- <br> -->
              Produk yang sering discan oleh customer berdasarkan nomor seri QR.
              <!-- {{ 'html-tooltip-button-title-' + circle_bg_color }} -->
            </b-tooltip>
          </h5>

          <div class="mr-4">
            <div
              class="input-group"
              style="
                position: relative;
                display: flex;
                flex-wrap: nowrap;
                align-items: stretch;
                width: 100%;
              "
            >
              <div class="input-group-append">
                <button
                  class="btn btn-outline-light text-gray bg-white"
                  type="button"
                  style="border-color: #d5dbe0; border-right: none; pointer-events: none"
                >
                  <i class="fa fa-search"></i>
                  <!-- Assuming you're using Font Awesome for the magnifier icon -->
                </button>
              </div>
              <Multiselect
                :options="[...new Set(highlightData.topScan.map((x) => x.material_no))]"
                placeholder="Search by Part Number"
                v-model="filter.topScanApi.part_number"
                :taggable="true"
                @tag="addPartNumberTag"
                @input="loadTopScan"
                style="border-color: white transparent transparent"
                class="custom-multiselect no-caret"
                :show-labels="false"
              >
                <!-- <template v-slot:caret="{ toggle }">
                    <i class="fas fa-search multiselect__search"></i>
                  </template> -->
              </Multiselect>
            </div>
          </div>
          <div>
            <div
              class="input-group"
              style="
                position: relative;
                display: flex;
                flex-wrap: nowrap;
                align-items: stretch;
                width: 100%;
              "
            >
              <div class="input-group-append">
                <button
                  class="btn btn-outline-light text-gray bg-white"
                  type="button"
                  style="border-color: #d5dbe0; border-right: none; pointer-events: none"
                >
                  <i class="fa fa-search"></i>
                  <!-- Assuming you're using Font Awesome for the magnifier icon -->
                </button>
              </div>
              <Multiselect
                :options="[...new Set(highlightData.topScan.map((x) => x.serial_number))]"
                placeholder="Search By Serial Number"
                v-model="filter.topScanApi.serial_number"
                :taggable="true"
                @tag="addSerialNumberTag"
                class="custom-multiselect no-caret"
                style="border-color: white transparent transparent"
                :show-labels="false"
              />
              <!-- <template v-slot:caret="{ toggle }">
                    <i class="fas fa-search multiselect__search"></i>
                  </template> -->
              <!-- </Multiselect> -->
            </div>
          </div>
        </div>
        <!-- <button class="btn btn-link" @click="scrollTo('statistic-summary')">
                    View Detail
                </button> -->
      </div>
      <hr class="mt-3" style="margin-bottom: 0" />

      <div class="">
        <table class="table frequently-scanned-table">
          <thead>
            <tr>
              <th style="padding-left: 20px">Serial Number</th>
              <th>Product Name</th>
              <th @click="toggleSortTotalScan">
                Jumlah Scan
                <span class="sort asc" v-if="sortOrderTotalScan === 'asc'">
                  <svg
                    width="6"
                    height="12"
                    viewBox="0 0 6 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M3 0L5.59808 3.75H0.401924L3 0Z" fill="#D9D9D9" />
                    <path d="M3 12L0.401924 8.25H5.59808L3 12Z" fill="#D9D9D9" />
                  </svg>
                </span>
                <span class="sort" v-else>
                  <svg
                    width="6"
                    height="12"
                    viewBox="0 0 6 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M3 0L5.59808 3.75H0.401924L3 0Z" fill="#D9D9D9" />
                    <path d="M3 12L0.401924 8.25H5.59808L3 12Z" fill="#D9D9D9" />
                  </svg>
                </span>
              </th>
              <th @click="toggleSortScanDate">
                Scan Date
                <span class="sort asc" v-if="sortOrderScanDate === 'asc'">
                  <!-- <svg fill="#000000" height="100%" width="100%" version="1.1" id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 330"
                    xml:space="preserve">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path id="XMLID_225_"
                        d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z">
                      </path>
                    </g>
                  </svg> -->
                  <svg
                    width="6"
                    height="12"
                    viewBox="0 0 6 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M3 0L5.59808 3.75H0.401924L3 0Z" fill="#D9D9D9" />
                    <path d="M3 12L0.401924 8.25H5.59808L3 12Z" fill="#D9D9D9" />
                  </svg>
                </span>
                <span class="sort" v-else>
                  <!-- <svg fill="#000000" height="100%" width="100%" version="1.1" id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 330"
                    xml:space="preserve">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path id="XMLID_225_"
                        d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z">
                      </path>
                    </g>
                  </svg> -->
                  <svg
                    width="6"
                    height="12"
                    viewBox="0 0 6 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M3 0L5.59808 3.75H0.401924L3 0Z" fill="#D9D9D9" />
                    <path d="M3 12L0.401924 8.25H5.59808L3 12Z" fill="#D9D9D9" />
                  </svg>
                </span>
              </th>
              <th colspan="2">Action</th>
              <!-- <th></th> -->
            </tr>
          </thead>
          <tbody style="color: #393939">
            <tr
              style="border-top: 1px solid #e6e6e6"
              v-for="(product, index) in sortedSerialNumber.slice(
                (filter.topScan.page - 1) * filter.topScan.limit,
                filter.topScan.page * filter.topScan.limit
              )"
            >
              <td style="padding-left: 20px">{{ product.serial_number }}</td>
              <td>
                <!-- <img src="https://storage.googleapis.com/ahmsparepart-staging/ahm_parts_brake-shoe.jpeg" class="mr-2" style="width: 45px;height: auto; border: 1px solid #E6E6E6; border-radius: 10px;"/> -->
                <img
                  :src="product.image"
                  class="mr-2"
                  style="width: 45px; height: auto; border: 1px solid #e6e6e6; border-radius: 10px"
                />
                {{ product.varian }}
              </td>
              <td>{{ product.total_scanned }}</td>
              <td>
                {{ moment(product.scan_date).format("YYYY-MM-DD HH:mm:ss") }}
              </td>
              <td>
                <div class="custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    style="position: static"
                    :id="'switch' + index"
                    v-model="product.status"
                    @change="toggleStatusProduct(product)"
                  />
                  <label
                    class="custom-control-label fw-bold"
                    :for="'switch' + index"
                    style="color: #9d9d9d"
                  >
                    {{ product.status ? "Active" : "Inactive" }}
                  </label>
                </div>
              </td>
              <td>
                <button
                  class="btn btn-outline-primary"
                  @click="viewJourney(product.qrcode, product.serial_number)"
                >
                  <img style="width: 15px; height: auto" src="@/assets/img/qr_journey.png" />
                  <span class="mt-2 ml-2">QR Journey</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr class="mt-3" />
      <div
        style="display: flex; align-items: center; justify-content: start; padding-left: 20px"
        class="w-100"
      >
        <div class="mr-3" style="color: #cbcbcb; font-size: 14px; font-family: 'Inter', sans-serif">
          Showing {{ (filter.topScan.page - 1) * filter.topScan.limit + 1 }} -
          {{
            filter.topScan.page * filter.topScan.limit <
            frequentlyScannedSerialNumberShownData.length
              ? filter.topScan.page * filter.topScan.limit
              : frequentlyScannedSerialNumberShownData.length
          }}
          of {{ frequentlyScannedSerialNumberShownData.length }} items
        </div>
        <!-- <button class="btn mr-2" @click="filter.topScan.page = 1"
                :disabled="filter.topScan.page === 1">&laquo;</button> -->
        <button
          class="btn"
          style="padding: 4px 8px"
          @click="filter.topScan.page -= 1"
          :disabled="filter.topScan.page === 1"
        >
          &lsaquo;
        </button>
        <!-- <span>Page {{ filter.topScan.page }} of {{ Math.ceil(frequentlyScannedSerialNumberShownData.length /
                filter.topScan.limit) }}</span> -->
        <button
          class="btn"
          style="padding: 4px 8px"
          @click="filter.topScan.page += 1"
          :disabled="
            filter.topScan.page >=
            Math.ceil(frequentlyScannedSerialNumberShownData.length / filter.topScan.limit)
          "
        >
          &rsaquo;
        </button>
        <!-- <button class="btn ml-2"
                @click="filter.topScan.page = Math.ceil(frequentlyScannedSerialNumberShownData.length / filter.topScan.limit)"
                :disabled="filter.topScan.page >= Math.ceil(frequentlyScannedSerialNumberShownData.length / filter.topScan.limit)">&raquo;</button> -->
      </div>
    </div>
    <!-- Frequently Scanned Serial Number End -->

    <!-- Latest Activity Start -->
    <!-- <div class="mb-4 innerBox">
                <div class="row">
                    <div class="col-lg-4 col-12 mt-auto mb-auto">
                        <h5>Latest Activity</h5>
                    </div>
                    <div class="offset-lg-5 col-lg-3 col-12 mb-1">
                        <div class="input-with-icon">
                            <input type="text" class="form-control" v-model="filter.latestActivity.search" placeholder="Search QR Code" style="padding-left: 32px;"/>
                            <span class="fa-placeholder"><i class="fa fa-search fa-lg"></i></span>
                        </div>
                    </div>
                </div>
                <hr class="mt-3">

                <div class="row">
                        <table class="table">
                            <thead>
                                <th  style="font-family: 'Proxima Nova';font-weight: normal;">Product Name</th>
                                <th  style="font-family: 'Proxima Nova';font-weight: normal;">Kode QR</th>
                                <th  style="font-family: 'Proxima Nova';font-weight: normal;">Device</th>
                                <th  style="font-family: 'Proxima Nova';font-weight: normal;">Scan Date</th>
                                <th  style="font-family: 'Proxima Nova';font-weight: normal;">Province</th>
                                <th  style="font-family: 'Proxima Nova';font-weight: normal;">Action</th>
                            </thead>
                            <tbody>
                                <tr v-for="data in highlightData.latestActivity.slice((filter.latestActivity.page - 1) * filter.latestActivity.limit , (filter.latestActivity.page) * filter.latestActivity.limit )">
                                    <td>
                                        <img :src="data.product_image" class="mr-2" style="width: 25px;height: auto;"/>
                                        {{data.product_name}}
                                    </td>
                                    <td>{{data.qrcode}}</td>
                                    <td>{{data.device}}</td>
                                    <td>{{moment(data.scan_date).format('MMM DD,Y HH:mm')}}</td>
                                    <td>{{data.nama_provinsi}}</td>
                                    <td>
                                        <button class="btn btn-outline-primary" @click="viewJourney(data.qrcode)">
                                            <img style="width: 15px;height: auto;" src="@/assets/img/qr_journey.png"/> <span class="mt-2 ml-2">Lihat Journey</span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div style="display: flex;align-items: center;justify-content: center;" class="w-100">
                            <button class="btn btn-secondary mr-2" @click="filter.latestActivity.page -= 1" :disabled="filter.latestActivity.page === 1"><</button>
                            <span>Page {{ filter.latestActivity.page }} of {{ Math.ceil(highlightData.latestActivity.length / filter.latestActivity.limit )}}</span>
                            <button class="btn btn-secondary ml-2" @click="filter.latestActivity.page += 1" :disabled="filter.latestActivity.page >= Math.ceil(highlightData.latestActivity.length / filter.latestActivity.limit )">></button>
                        </div>
                </div>
                
        </div> -->
    <!-- Latest Activity End -->

    <FrequentlyScannedProductPopUp
      :fields="[]"
      :urlAPI="modal.frequentlyScannedProduct.api"
      :name="modal.frequentlyScannedProduct.name"
      :total="modal.frequentlyScannedProduct.total"
      v-if="modal.frequentlyScannedProduct.api"
      @closeModal="modal.frequentlyScannedProduct.api = null"
      latVar="lat"
      lngVar="lng"
    />
  </div>
</template>

<script>
// import AktivasiAktivasi from './children/AktivasiAktivasi.vue';
// import ProvinceTable from './children/ProvinceTable.vue';
// import ProviceChart from './children/ProviceChart.vue';
import highlightStats from "./children/HighlightStats.vue";

import qs from "qs";
import debounce from "debounce";

import Map from "./children/Map.vue";
import GoogleMap from "./children/GoogleMap.vue";
import moment from "moment";
import Multiselect from "vue-multiselect";
import highlightChart from "./children/HighlightChart.vue";

import FrequentlyScannedProductPieChart from "./children/FrequentlyScannedProductPieChart.vue";

import testImage from "@/assets/img/test_image.png";
import FrequentlyScannedProductPopUp from "./children/FrequentlyScannedProductPopUp.vue";
import { DateAxisDataItem } from "@amcharts/amcharts4/charts";
import { mapState, mapActions } from "vuex";
export default {
  metaInfo: {
    title: "Highlights",
  },
  components: {
    // AktivasiAktivasi,
    Map,
    GoogleMap,
    Multiselect,
    // ProvinceTable,
    // ProviceChart,
    highlightStats,
    highlightChart,
    FrequentlyScannedProductPieChart,
    FrequentlyScannedProductPopUp,
  },
  mounted() {
    // this.loadApi(null , null)
    this.loadStatsData();
    this.loadFrequentlyScannedProduct();
    this.loadTopScan();
    // this.loadLatestActivity()
    // this.loadActivityTrend()
    this.loadMostActiveRegion();
  },
  watch: {
    "filter.latestActivity.search": function () {
      this.filter.latestActivity.page = 1;

      if (this.filter.latestActivity.search == null || this.filter.latestActivity.search == "")
        this.highlightData.latestActivity = Object.assign([], this.highlightData.fullActivity);
      else
        this.highlightData.latestActivity = this.highlightData.fullActivity.filter((x) =>
          x.qrcode.toLowerCase().includes(this.filter.latestActivity.search.toLowerCase())
        );
    },
    "selected.topScanDate": function () {
      // this.debounceMethod('loadTopScan' , this , 'topScan' , 'topScanDate')
      // this.loadTopScan()
    },
    "selected.date": function () {
      // console.log(this.filter.map.start , this.filter.map.end)
      // this.debounceMethod('loadMostActiveRegion' , this , 'map' , 'date')
      // this.loadMostActiveRegion()
    },
    "filter.topScanApi.serial_number"() {
      this.loadTopScan();
    },
    "filter.topScanApi.part_number"() {
      this.loadTopScan();
    },
    "selected.universalDate": function () {
      console.log("tanggal ", this.selected.universalDate);
      this.selected.date = this.selected.universalDate;
      this.selected.topScanDate = this.selected.universalDate;

      this.debounceMethod(this, [
        {
          functionName: "loadStatsData",
          filterVar: "stats",
          selectedVar: "date",
        },
        {
          functionName: "loadMostActiveRegion",
          filterVar: "map",
          selectedVar: "date",
        },
        {
          functionName: "loadFrequentlyScannedProduct",
          filterVar: "frequentlyScannedProductApi",
          selectedVar: "date",
        },
        {
          functionName: "loadTopScan",
          filterVar: "topScanApi",
          selectedVar: "topScanDate",
        },
      ]);
    },
    "filter.period": function () {
      if (this.filter.period == "This Year") {
        this.filter.activityTrend.start = new moment().startOf("year").format("Y-MM-DD");
        this.filter.activityTrend.end = new moment().endOf("year").format("Y-MM-DD");
      } else {
        this.filter.activityTrend.start = new moment()
          .startOf("month")
          .add("-12", "month")
          .format("Y-MM-DD");
        this.filter.activityTrend.end = new moment().endOf("month").format("Y-MM-DD");
      }
    },
    "filter.activityTrend": {
      deep: true,
      handler() {
        this.loadActivityTrend();
      },
    },
    "filter.map": {
      deep: true,
      handler() {
        // console.log('test')
        this.loadMostActiveRegion();

        this.updateIsIndonesia(true);
      },
    },

    "filter.topScan.serial_number"() {
      if (this.filter.topScan.serial_number) {
        this.filter.topScan.page = 1;
      }
    },
    "filter.topScan.material_no"() {
      if (this.filter.topScan.material_no) {
        this.filter.topScan.page = 1;
      }
    },
  },
  data() {
    let startOfMonth = new moment().startOf("month");

    let endOfMonth = new moment().endOf("month");

    let startOfYear = new moment().startOf("year");
    let endOfYear = new moment().endOf("year");

    let formattedStartOfYear = startOfYear.format("Y-MM-DD");
    let formattedEndOfYear = endOfYear.format("Y-MM-DD");
    return {
      moment,
      modal: {
        frequentlyScannedProduct: {
          api: null,
          name: null,
          total: null,
        },
      },
      rangePickr: {
        mode: "range",
        dateFormat: "d/m/Y",
        altInput: true,
        altFormat: "d/m/Y",
        altInputClass: "form-control input elegant-flatpickr border-left-0",
      },
      selected: {
        // dateButtonsIndex : 2,
        date: `${startOfYear.format("DD/MM/Y")} to ${endOfYear.format("DD/MM/Y")}`,
        topScanDate: `${startOfYear.format("DD/MM/Y")} to ${endOfYear.format("DD/MM/Y")}`,
        universalDate: `${startOfYear.format("DD/MM/Y")} to ${endOfYear.format("DD/MM/Y")}`,
      },
      invokeCenter: null,
      mapDemoData: null,
      tooltipDataTotalQR: "",
      // kabupatenDataSum : 0,
      // kecamatanDataSum : 0,
      // kelurahanDataSum : 0,
      // tpsDataSum : 0,
      masterLegend: {
        genuine: [
          {
            filter: ">80% Genuine",
            min: 80,
            color: "#1da967",
          },
          {
            filter: "60% - 80%",
            min: 60,
            max: 80,
            color: "#21d182",
          },
          {
            filter: "40% - 60%",
            min: 40,
            max: 60,
            color: "#c8eadb",
          },
          {
            filter: "20% - 40%",
            min: 20,
            max: 40,
            color: "#f7e47a",
          },
          {
            filter: "5% - 20%",
            min: 5,
            max: 20,
            color: "#fff7c7",
          },
          {
            filter: "<5% Genuine",
            max: 5,
            color: "#ffffff",
          },
        ],
        counterfeit: [
          {
            filter: ">80% Counterfeit",
            min: 80,
            color: "#d93736",
          },
          {
            filter: "60% - 80%",
            min: 60,
            max: 80,
            color: "#f27979",
          },
          {
            filter: "40% - 60%",
            min: 40,
            max: 60,
            color: "#ffc5c4",
          },
          {
            filter: "20% - 40%",
            min: 20,
            max: 40,
            color: "#f7c075",
          },
          {
            filter: "5% - 20%",
            min: 5,
            max: 20,
            color: "#ffecd1",
          },
          {
            filter: "<5% Counterfeit",
            max: 5,
            color: "#ffffff",
          },
        ],
      },
      filter: {
        activityTrend: {
          product_id: null,
          province_id: null,

          start: formattedStartOfYear,
          end: formattedEndOfYear,
        },
        map: {
          filter_by: "serial_number",
          search: "",
          start: formattedStartOfYear,
          end: formattedEndOfYear,
          status: "genuine",
        },
        stats: {
          start: formattedStartOfYear,
          end: formattedEndOfYear,
        },
        latestActivity: {
          search: "",
          page: 1,
          limit: 10,
        },
        frequentlyScannedProductApi: {
          start: formattedStartOfYear,
          end: formattedEndOfYear,
        },
        frequentlyScannedProduct: {
          material_no: null,
          page: 1,
          limit: 10,
        },
        topScanApi: {
          start: formattedStartOfYear,
          end: formattedEndOfYear,
          part_number: null,
          serial_number: null,
        },
        topScan: {
          serial_number: null,
          material_no: null,
          page: 1,
          limit: 10,
        },
        topScanTable: {},
        period: "This Year",
      },
      filterOptions: {
        products: this.$store.getters.getProducts,
        provinsi: this.$store.getters.getProvinsi,
        scan: [
          {
            name: "Activity By Register",
            value: "register",
          },
          {
            name: "Activity By Scan",
            value: "scan",
          },
        ],
      },
      highlightData: {
        stats: {
          total_qr: null,
          total_scan: null,
          genuine_found: null,
          counterfeit_found: null,
        },
        latestActivity: [],
        fullActivity: [],
        frequentlyScannedProduct: [],
        topScan: [],
        activityTrend: [],
        mostActiveRegion: null,
        newStats: {},
      },
      selectQR: null,
      apiFlag: false,
      user: this.$store.getters.currentUser,
      circle_bg_color: "#f1edfc",
      circle_text_color: "#a94be4",
      sortOrder: "desc",
      sortOrderTotalScan: "desc",
      sortOrderScanDate: "desc",
      activeSortColumn: "totalScan", // Track which column is being sorted
    };
  },
  computed: {
    frequentlyScannedProductShownData() {
      return this.highlightData.frequentlyScannedProduct.filter(
        (x) =>
          this.filter.frequentlyScannedProduct.material_no == null ||
          x.material_no == this.filter.frequentlyScannedProduct.material_no
      );
    },
    frequentlyScannedSerialNumberShownData() {
      return this.highlightData.topScan
        .filter(
          (x) =>
            this.filter.topScan.material_no == null ||
            x.material_no == this.filter.topScan.material_no
        )
        .filter(
          (x) =>
            this.filter.topScan.serial_number == null ||
            x.serial_number == this.filter.topScan.serial_number
        );
    },
    ...mapState("maps", {
      isIndonesia: (state) => state.isIndonesia,
    }),
    isVanBelt() {
      return this.user.product_category === "vanbelt";
    },
    isCrossClientCategory4() {
      return this.user && this.user.product_category_id == 4;
    },
    useCustomCounterfeitTooltip() {
      return this.user && [2, 3, 4].includes(Number(this.user.product_category_id));
    },
    sortedProducts() {
      return [...this.frequentlyScannedProductShownData].sort((a, b) => {
        const multiplier = this.sortOrder === "asc" ? 1 : -1;
        return (a.total - b.total) * multiplier;
      });
    },
    sortedSerialNumber() {
      return [...this.frequentlyScannedSerialNumberShownData].sort((a, b) => {
        if (this.activeSortColumn === "totalScan") {
          const multiplier = this.sortOrderTotalScan === "asc" ? 1 : -1;
          return (a.total_scanned - b.total_scanned) * multiplier;
        } else if (this.activeSortColumn === "scanDate") {
          const multiplier = this.sortOrderScanDate === "asc" ? 1 : -1;
          const dateA = new Date(a.scan_date);
          const dateB = new Date(b.scan_date);
          return (dateA - dateB) * multiplier;
        }
        return 0;
      });
    },
  },
  methods: {
    titleCase(str) {
      return str
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
    },
    addSerialNumberTag(val) {
      this.filter.topScanApi.serial_number = val;
    },
    addPartNumberTag(val) {
      this.filter.topScanApi.part_number = val;
    },
    handleClick() {
      const range = this.selected.universalDate;

      if (!this.isDateRangeWithinOneMonth(range)) {
        this.$swal.fire({
          title: "Location View Unavailable",
          html: `Location data cannot be displayed when your selected date range exceeds one month. Please select a range of <strong>one month</strong> or <strong>less</strong> to view the location.`,
          icon: "warning",
          confirmButtonColor: "#267CE5",
          didOpen: () => {
            const confirmButton = document.querySelector(".swal2-confirm");
            if (confirmButton) {
              confirmButton.style.flex = "1";
            }
          },
        });
        return;
      }

      this.$router.push({
        name: "HighlightsCounterfeitLocation",
        query: {
          start: this.filter.stats.start,
          end: this.filter.stats.end,
        },
      });
    },
    isDateRangeWithinOneMonth(rangeString) {
      let startDate, endDate;

      const parseDMY = (str) => {
        const [d, m, y] = str.split("/");
        return new Date(parseInt(y), parseInt(m) - 1, parseInt(d));
      };

      if (rangeString.includes(" to ")) {
        const parts = rangeString.split(" to ");
        if (parts.length !== 2) return false;
        startDate = parseDMY(parts[0]);
        endDate = parseDMY(parts[1]);
      } else {
        // Single date: treat as same-day range
        startDate = endDate = parseDMY(rangeString);
      }

      // Validate dates
      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        return false;
      }

      // Ensure correct order
      if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }

      const diffMs = endDate - startDate;
      const diffDays = diffMs / (1000 * 60 * 60 * 24);

      return diffDays < 31;
    },
    handleMapWheel(event) {
      if (event.ctrlKey) {
        event.preventDefault(); // Prevent the default zoom behavior
        const map = this.$refs.map.$mapObject; // Access the underlying Google Map object
        const currentZoom = map.getZoom();
        const delta = event.deltaY > 0 ? -1 : 1; // Adjust the delta as needed
        const newZoom = currentZoom + delta;

        // Set bounds to prevent zooming too far in or out
        const minZoom = 1;
        const maxZoom = 20;
        const zoomLevel = Math.min(maxZoom, Math.max(minZoom, newZoom));

        map.setZoom(zoomLevel); // Update the zoom level
      }
    },
    getColorForValue(value, legend) {
      for (const item of legend) {
        if (
          (item.min === undefined || value >= item.min) &&
          (item.max === undefined || value <= item.max)
        ) {
          return item.color;
        }
      }
      return null; // Return null or a default color if no match is found
    },
    debounceMethod: debounce((vm, loadFunction) => {
      for (var i = 0; i < loadFunction.length; i++) {
        let selectedVar = loadFunction[i].selectedVar;
        let filterVar = loadFunction[i].filterVar;
        let value = loadFunction[i].functionName;

        let split = vm.selected[selectedVar].split(" to ");
        vm.filter[filterVar].start = moment(split[0], "DD/MM/Y").format("Y-MM-DD");
        vm.filter[filterVar].end =
          split.length > 1
            ? moment(split[1], "DD/MM/Y").format("Y-MM-DD")
            : moment(split[0], "DD/MM/Y").format("Y-MM-DD");
        vm[value]();
      }
    }, 1500),
    viewJourney(qrcode, serialNumber) {
      this.$router.push({
        name: "HighlightsQRJourney",
        query: { qrcode: qrcode, serial_number: serialNumber },
      });
    },
    distributeRandomly(length, total, max) {
      let amounts = [];
      let sum = 0;

      for (let i = 0; i < length; i++) {
        // Calculate the maximum possible value for this item
        let currentMax = Math.min(max, total - sum - (length - i - 1));
        let amount = Math.floor(Math.random() * currentMax) + 1;

        amounts.push(amount);
        sum += amount;
      }

      // Distribute the remaining amount
      let remaining = total - sum;
      while (remaining > 0) {
        for (let i = 0; i < length && remaining > 0; i++) {
          if (amounts[i] < max) {
            amounts[i]++;
            remaining--;
          }
        }
      }

      return amounts;
    },
    toggleSort() {
      this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
    },
    toggleSortTotalScan() {
      this.activeSortColumn = "totalScan";
      this.sortOrderTotalScan = this.sortOrderTotalScan === "asc" ? "desc" : "asc";
    },
    toggleSortScanDate() {
      this.activeSortColumn = "scanDate";
      this.sortOrderScanDate = this.sortOrderScanDate === "asc" ? "desc" : "asc";
    },
    async loadActivityData() {
      try {
        let response = await this.$http.get(
          `/api/highlight/activities?${qs.stringify(this.filter.aktivasi)}`
        );

        this.activityData = response.data.data;
      } catch (err) {
        console.log(err);
      }
    },
    getColor(persen) {
      persen = parseFloat(persen);

      if (persen == 0) {
        return "#fbb9b9";
      } else if (persen <= 10) {
        return "rgba(162, 218, 162 , 0.1)";
      } else {
        return `rgba(162, 218, 162 , ${(Math.round(persen / 10) * 10) / 100})`;
      }
    },
    async loadStatsData() {
      let url = [
        {
          url: "/dashboard/total-qr",
          variable: "total_qr",
        },
        {
          url: "/dashboard/total-scan",
          variable: "total_scan",
        },
        {
          url: "/dashboard/genuine-found",
          variable: "genuine_found",
        },
        {
          url: "/dashboard/counterfeit-found",
          variable: "counterfeit_found",
        },
      ];
      try {
        for (var i = 0; i < url.length; i++) {
          this.highlightData.stats[url[i].variable] = null;

          let resp = await this.$http.get(url[i].url + "?" + qs.stringify(this.filter.stats));

          let data = resp.data.data;

          if (url[i].variable == "total_qr") {
            this.tooltipDataTotalQR = data;
            this.highlightData.newStats = data;
          }

          this.highlightData.stats[url[i].variable] = parseInt(resp.data.data.total);
        }
        // console.log(this.highlightData.newStats);
      } catch (err) {
        // console.log(err);
      }
    },
    formatNumber(num) {
      if (num == null || isNaN(num)) return "0";
      if (num >= 1000000000) {
        return Math.floor(num / 100000000) / 10 + "B";
      }
      if (num >= 1000000) {
        return Math.floor(num / 100000) / 10 + "M";
      }
      if (num >= 1000) {
        return Math.floor(num / 100) / 10 + "K";
      }
      return num.toString();
    },
    async loadLatestActivity() {
      try {
        let resp = await this.$http.get("/dashboard/last-activity");

        this.highlightData.fullActivity = JSON.parse(JSON.stringify(resp.data.data));

        this.highlightData.latestActivity = resp.data.data;
      } catch (err) {
        console.log(err);
      }
    },
    async loadFrequentlyScannedProduct() {
      try {
        this.highlightData.frequentlyScannedProduct = [];
        let resp = await this.$http.get(
          "/dashboard/frequently-scanned-product?" +
            qs.stringify(this.filter.frequentlyScannedProductApi)
        );

        this.highlightData.frequentlyScannedProduct = resp.data.data;
      } catch (err) {
        // console.log(err);
      }
    },
    async toggleStatusProduct(product) {
      const qrcode = product.qrcode;
      const newStatus = product.status ? 1 : 0;

      product.status = newStatus;

      try {
        await this.$http.put("/dashboard/frequently-scanned-serial-update-status", {
          qrcode: qrcode,
          status: newStatus,
        });
      } catch (error) {
        // console.error("Error updating status:", error);
        product.status = !newStatus;
      }
    },

    async loadTopScan() {
      try {
        this.highlightData.topScan = [];
        let resp = await this.$http.get(
          "/dashboard/top-ten-scanned-qr?" + qs.stringify(this.filter.topScanApi)
        );

        this.highlightData.topScan = JSON.parse(JSON.stringify(resp.data.data)).map((x) => {
          x.active = true;
          return x;
        });
        // console.log(this.highlightData.topScan);
      } catch (err) {
        console.log(err);
      }
    },
    async loadActivityTrend() {
      try {
        this.highlightData.activityTrend = [];
        let resp = await this.$http.get(
          "/dashboard/activity-trend?" + qs.stringify(this.filter.activityTrend)
        );

        this.highlightData.activityTrend = JSON.parse(JSON.stringify(resp.data.data));
      } catch (err) {
        console.log(err);
      }
    },
    async loadMostActiveRegion() {
      try {
        if (this.apiFlag) return;
        this.apiFlag = true;
        this.highlightData.mostActiveRegion = null;

        let mapJSON = JSON.parse(JSON.stringify(this.filter.map));
        this.settingFilter(qs.stringify(mapJSON));

        if (mapJSON.status == "all result") delete mapJSON.status;

        let resp = await this.$http.get("/dashboard/most-active-region?" + qs.stringify(mapJSON));

        // deep copy of response data
        let data = JSON.parse(JSON.stringify(resp.data.data || []));

        // ensure numeric fields (defensive)
        data = data.map((r) => ({
          ...r,
          counterfeit: Number(r.counterfeit || 0),
          genuine: Number(r.genuine || 0),
          total_scan: Number(r.total_scan || 0),
          percentage: Number(r.percentage || 0),
        }));

        // console.log("data heklek for map", data);

        if (this.filter.map.status === "counterfeit") {
          data.forEach((obj) => delete obj.genuine);
          data.sort((a, b) => {
            if (b.counterfeit !== a.counterfeit) return b.counterfeit - a.counterfeit;
            return b.total_scan - a.total_scan;
          });
        } else if (this.filter.map.status === "genuine") {
          data.forEach((obj) => delete obj.counterfeit);
          data.sort((a, b) => {
            if (b.genuine !== a.genuine) return b.genuine - a.genuine;
            return b.total_scan - a.total_scan;
          });
        } else {
          data.sort((a, b) => b.total_scan - a.total_scan);
        }
        this.highlightData.mostActiveRegion = data;
        this.apiFlag = false;
      } catch (err) {
        console.log(err);
        this.apiFlag = false;
      }
    },
    scrollTo(id) {
      document.getElementById(id).scrollIntoView({ behavior: "smooth" });
    },
    openFrequentlyScannedProductMap(data) {
      // this.modal.frequentlyScannedProduct.api = '/dashboard/frequently-scanned-product-detail?product_id=' + data.id + '&' + qs.stringify(this.filter.frequentlyScannedProductApi)
      // this.modal.frequentlyScannedProduct.name = data.name
      // this.modal.frequentlyScannedProduct.total = data.total
      const range = this.selected.universalDate;

      if (!this.isDateRangeWithinOneMonth(range)) {
        this.$swal.fire({
          title: "Location View Unavailable",
          html: `Location data cannot be displayed when your selected date range exceeds one month. Please select a range of <strong>one month</strong> or <strong>less</strong> to view the location.`,
          icon: "warning",
          confirmButtonColor: "#267CE5",
          didOpen: () => {
            const confirmButton = document.querySelector(".swal2-confirm");
            if (confirmButton) {
              confirmButton.style.flex = "1";
            }
          },
        });
        return;
      }

      this.$router.push({
        name: "HighlightsFrequentlyScannedProductMap",
        query: {
          ...this.filter.frequentlyScannedProductApi,
          product_id: data.id,
        },
      });
    },
    /*    this.modal.frequentlyScannedProduct.api = '/dashboard/frequently-scanned-product-detail?product_id=' + data.id + '&' + qs.stringify(this.filter.frequentlyScannedProductApi)
              this.modal.frequentlyScannedProduct.name = data.name
              this.modal.frequentlyScannedProduct.total = data.total
          }, */
    ...mapActions("maps", ["updateIsIndonesia", "settingFilter"]),
  },
  formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
};
</script>

<style scoped>
/* .frequently-scanned-table-header {
    
    color: #4B4B4B;
  } */

.back_Button {
  cursor: pointer;
  font-weight: bolder;
  font-size: 20px;
}

.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.statsData {
  padding: 10px 7px;
}

.stats {
  font-size: 1.3rem;
  font-weight: 600;
}

.bg-kabupaten {
  background-color: darkorange;
}

.bg-kecamatan {
  background-color: blueviolet;
}

.bg-desakel {
  background-color: darkslategray;
}

.bg-tps {
  background-color: dodgerblue;
}

.column-region {
  height: 400px;
  overflow-y: scroll;
}

.multiselect__select {
  position: absolute;
  width: 40px;
  height: 38px;
  right: 1px;
  top: 1px;
  padding: 4px 8px;
  text-align: center;
  opacity: 0;
}

/* Add the following style rule to hide the arrow icon */
.custom-multiselect .multiselect__select {
  background: none !important;
  border: 1px solid #ccc;
  border-radius: 0px;
  padding: 8px;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #57cb8c;
  background-color: #57cb8c;
}

.custom-switch {
  width: 96px;
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  color: #c9c9c9;
  transform: translateX(0.75rem);
}

.no-caret .multiselect__select:before {
  border-color: transparent;
}

.multiselect__tags {
  min-height: 40px;
  display: block;
  padding: 8px 40px 0 8px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 14px;
}
</style>

<style scoped>
.stats--title {
  font-size: 13px;
  font-weight: bold;
  color: #383838;
}

th {
  border-top: none;
}

.horizontal-line {
  border-top: 1px solid #a2a2a2;
  margin: 5px 0;
  width: 100%;
  height: 1px;
}

.input-with-icon {
  position: relative;
}

.fa-placeholder {
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
  /* This ensures the solid icon is used */
  position: absolute;
  left: 10px;
  /* Adjust as needed */
  top: 50%;
  transform: translateY(-50%);
  color: #ccc;
  /* Placeholder-like color */
  pointer-events: none;
  /* Ensures clicks go through to the input */
}

.form-control {
  padding-left: 125px;
  /* Make space for the icon */
}

.progress-container {
  display: flex;
  align-items: center;
  /* Center vertically */
}

.progress {
  flex-grow: 1;
  /* Allow progress bar to take full width */
}

.value-label {
  margin-left: 10px;
  /* Spacing between progress bar and label */
  white-space: nowrap;
  /* Prevents wrapping of the label */
}

.frequently-scanned-table th,
.frequently-scanned-table td {
  vertical-align: middle;
}

.frequently-scanned-table th {
  font-weight: normal;
  /* Set the font weight to normal */
  font-size: 12px !important;
  color: #4b4b4b;
  /* Set the font size to 14px */
}

.frequently-scanned-table td {
  border: 0;
}

.sort {
  cursor: pointer;
  /* font-size: 0.5rem; */
  display: inline-block;
  width: 8px;
  height: 8px;
  transform-origin: center;
}

.sort.asc svg {
  transform: rotate(180deg);
}

.max-description {
  /* width: 500px; */
  max-width: 350px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media screen and (max-width: 1400px) {
  .max-description {
    max-width: 300px;
  }
}

@media screen and (max-width: 1100px) {
  .max-description {
    max-width: 200px;
  }
}

.no-caret .multiselect__select:before {
  border-color: transparent;
}
</style>

<style>
/* .map-legend {
    border: none;
  } */
/* .multiselect {
    border-left: -2px;
   } */

.custom-multiselect .multiselect__placeholder {
  font-family: "Inter", sans-serif;
}

.dropdown-custom .multiselect {
  position: relative;
  display: inline-block;
  width: 100%;
}

.dropdown-custom .multiselect__single,
.dropdown-custom .multiselect__placeholder,
.dropdown-custom .multiselect__input,
.dropdown-custom .multiselect__tags {
  color: #4b4b4b;
}

.dropdown-custom .multiselect__select {
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 100%;
  padding: 0;
  margin: 0;
  text-align: center;
  border-left: none;
  z-index: 1;
}

.dropdown-custom .multiselect__select:before {
  display: none !important;
}

.dropdown-custom .multiselect__select:after {
  content: "";
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 7px;
  height: 4px;
  background-image: url("~@/assets/img/multiselect-chevron.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: none;
  transition: transform 0.2s ease;
}

.dropdown-custom .multiselect--active .multiselect__select:after {
  transform: translateY(-50%) rotate(180deg);
}

.dropdown-custom .multiselect__tags {
  padding-right: 40px;
}

.multiselect__tags {
  margin-left: -2px;
}

.multiselect__placeholder {
  font-size: 12px;
  color: #c9c9c9;
  /* font-family: 'Inter', sans-serif; */
}

.elegant-flatpickr {
  font-size: 12px;
}

.tooltip.b-tooltip {
  opacity: 1;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
}

.tooltip-inner {
  background-color: white;
  color: #aaa;
  font-family: "DM Sans", sans-serif;
  /* border: 1px solid #D3D3D3; */
}

.arrow::before {
  border-color: transparent;
  border-bottom-color: white;
  opacity: 0;
  /* Adjust this based on the tooltip position */
}

.no-caret .multiselect__select:before {
  border-color: transparent;
}

.highlights-total .innerBox {
  padding: 0;
}

.highlights-total > div > .innerBox > .d-flex:last-child {
  height: 122px;
}

.highlight--stats {
  background-color: white;
  border-radius: 8px;
  /* box-shadow: 0px 3px 10px #0000000F; */
  /* padding: 15px 0px; */

  display: flex;
  flex-direction: column;
  /* align-items: center; */
  justify-content: center;
}

.total-product {
  background-color: #fafafa;
  border-radius: 4px;
  height: 100%;
  margin-left: 4px;
  margin-right: 4px;
  width: 100%;
  height: 70px;
  text-align: center;
}

.total-product span:nth-child(1) {
  color: #a0a0a0;
  font-weight: 500;
}

.total-product span:nth-child(2) {
  color: #383838;
  font-weight: 700;
  font-size: 1rem;
}

.border-right {
  border-right: 1px solid #e8e8e8;
}

.border-bottom {
  border-bottom: 1px solid #e8e8e8;
}

.value--unit {
  display: flex;
  flex-direction: row;
  /* justify-content: center; */
  justify-content: flex-start;
  align-items: flex-end;
}

.stats--title {
  font-size: 13px;
  font-weight: bold;
  color: #383838;
}

.stats--value {
  font-size: 30px;
  font-weight: bold;
  color: #383838;
  font-family: "Inter", sans-serif;
}

.stats--unit {
  font-size: 14px;
  font-weight: 500;
  color: #d1d1d1;
  padding: 0 0 10px 10px;
}

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.circle {
  /* Circle size */
  width: 57px;
  height: 57px;

  /* Make it a circle */
  border-radius: 50%;

  /* Circle color */
  /* Red color for demonstration */

  /* Centering the circle inside the container */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
}
.left-aligned-tooltip .tooltip-inner {
  max-width: 350px !important;
}
</style>
